export const branchBookingTypes = {
  PHYSCIAL: 1,
  TELEHEALTH: 2,
  HOME_VISIT: 3,
  PRIMARY_CARE: 4,
  PHYSCIAL_LAB: 5,
  PHYSCIAL_SCAN: 6,
};
